import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Eye, EyeOff, Lock, Mail, ShieldCheck } from "lucide-react";
import { Btn, Field } from "@/components/kit";
import { useAdminAuth } from "@/context/auth";
import { OWNER_EMAIL } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const { admin, login } = useAdminAuth();
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (admin) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    if (!password) return setError("Enter your admin password.");
    setBusy(true);
    setError("");
    try { await login(OWNER_EMAIL, password); nav("/admin"); }
    catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-md t-card p-7 fade-up shadow-[0_20px_50px_-30px_rgba(15,23,42,.4)]" data-testid="admin-login-form">
        <ShieldCheck className="w-12 h-12 text-[#0000EC]" />
        <h1 className="mt-4 text-[26px] font-extrabold" data-testid="admin-login-heading">Manage TOTO, from TOTO.</h1>
        <p className="mt-1 text-[14px] text-[#475569]">Confirm your account password to open Admin. This access is reserved for the owner account only.</p>
        <div className="flex flex-col gap-4 mt-6">
          <Field label="Admin email" icon={Mail} value={OWNER_EMAIL} readOnly className="[&_.t-input]:text-[#475569]" testid="admin-email" />
          <Field label="Password" icon={Lock} type={show ? "text" : "password"} placeholder="Your admin password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" testid="admin-password"
            right={<button type="button" className="w-10 h-10 flex items-center justify-center text-[#64748B]" onClick={() => setShow(!show)} data-testid="admin-password-toggle">{show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}</button>} />
          {error && <p className="text-[14px] text-[#DC2626]" data-testid="admin-login-error">{error}</p>}
          <Btn type="submit" loading={busy} testid="admin-sign-in">Sign in to Admin</Btn>
        </div>
        <p className="mt-5 text-[12px] text-[#64748B]">Restricted access. Scanned contact details, card images and notes remain private to each user.</p>
      </form>
    </div>
  );
}
